import { resolveId } from '@medplum/core'
import type { AllergyIntolerance, Reference } from '@medplum/fhirtypes'
import { ExtendedAllergy } from '@seen/core/models/allergies'
import { cn } from '@seen/ui'
import type { JSX } from 'react'
import { HoverCard } from '#src/components/core/hover-card/HoverCard.tsx'
import { HoverCardContent } from '#src/components/core/hover-card/HoverCardContent.tsx'
import { HoverCardTrigger } from '#src/components/core/hover-card/HoverCardTrigger.tsx'
import { Link } from '#src/components/core/Link.tsx'
import { AllergyCard } from '#src/components/patient/detail-content/AllergyCard.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function AllergyMention({
  allergy: allergyReference,
  className,
  displayOverride,
}: {
  allergy: Reference<AllergyIntolerance>
  className?: string
  displayOverride?: string | null
}): JSX.Element {
  const allergyId = resolveId(allergyReference)

  const { data: allergy } = useRead(ExtendedAllergy, allergyReference)
  const participantId = resolveId(allergy?.patient)
  const allergyUrl = `/Patient/${participantId}/allergies/${allergyId}`

  return (
    <HoverCard openDelay={300} closeDelay={200}>
      <HoverCardTrigger asChild>
        <Link
          to={allergyUrl}
          className={cn(
            'select-none rounded-sm border-[0.5px] border-gray-450 bg-gray-470 box-decoration-clone px-1 py-px hover:bg-gray-460 group-[.ProseMirror-selectednode]:bg-[lch(53_52.26_286.91/0.4)] [&&]:no-underline',
            className
          )}
          tabIndex={-1}
        >
          <span>{displayOverride || allergy?.name}</span>
        </Link>
      </HoverCardTrigger>
      {allergy && (
        <HoverCardContent side="bottom" align="start" className="w-auto">
          <AllergyCard allergy={allergy} to={allergyUrl} />
        </HoverCardContent>
      )}
    </HoverCard>
  )
}
